module.exports = __webpack_public_path__ + "img/t13.9327b6a5.png";